export default __webpack_public_path__ + "static/media/tcs_dashboard.071b008a.png";